export default "__VITE_ASSET__CVXZO26K__"